import { PermissionDto, ResourceType, UserPermissionsDto } from '../common/PricePrgClient';
import { notNull } from './arrayUtils';

export const createAdminPermission = (resourceType: ResourceType, recordId?: number): PermissionDto => ({
    canCreate: true,
    canDelete: true,
    canRead: true,
    canUpdate: true,
    resourceType: resourceType,
    recordId: recordId
});

export const getPermission = (
    resource: ResourceType,
    recordId: number | null,
    userPermissions: UserPermissionsDto
) => {
    if (recordId == null) {
        return null;
    }

    if (userPermissions.isAdmin) {
        return createAdminPermission(resource, recordId);
    }

    const permissions = userPermissions.recordPermissions.find(x => x.resourceType === resource);
    if (permissions == null) {
        return null;
    }

    return permissions.recordPermissions.find(x => x.recordId === recordId);
};
//Determines whether a user can see the stock column or not
export const canSeeStockColumn = (currentField: string | undefined, userPermissions: UserPermissionsDto) => {
    return !(currentField == 'stock' && userPermissions.userGroups.some(ug => ug.hideWarehouseBalance));
};

export const getPermissions = (
    resource: ResourceType,
    recordIds: number[],
    userPermissions: UserPermissionsDto
) => {
    if (userPermissions.isAdmin) {
        return recordIds.map(id => createAdminPermission(resource, id));
    }

    const permissions = userPermissions.recordPermissions.find(x => x.resourceType === resource);
    if (permissions == null) {
        return [];
    }

    return recordIds.map(id => permissions.recordPermissions.find(x => x.recordId === id)).filter(notNull);
};

export const hasPermission = (userPermissions: UserPermissionsDto, resourceType: ResourceType) =>
    userPermissions.isAdmin || userPermissions.accessiblePages.includes(resourceType);
